
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, MenuItem, TextField } from "@mui/material"
import { InputSeparadorDecimal } from "../../inputs/InputSeparadorDecimal";
import { useQueryClient } from "@tanstack/react-query";
import { useCategoriasQuery, useProveedoresQuery, useUniMedidaQuery } from "../../../../hooks";
import { startSavingProducto } from "../../../../services";
import { AutocompleteMultiple } from "../../inputs/AutocompleteMultiple";

import Swal from "sweetalert2";





export const FormCreateUpdateProducto = ({ initialState }) => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { unimedidaListQuery } = useUniMedidaQuery();
    const { proveedoresListQuery } = useProveedoresQuery();
    const { categoriasQuery } = useCategoriasQuery()


    const [formProducto, setFormProducto] = useState( initialState );
    const { nombre, precioSin, proveedor, detalles, unidadMedida, iva, categoria } = formProducto;
    const  handleChangeInput = ({ target }) => {
        setFormProducto({ ...formProducto, [target.name]: target.value});
    }

    
    
    const crearActInformacion = async(e) => {
        e.preventDefault();

        if([nombre, precioSin, proveedor, detalles, unidadMedida, iva, categoria].includes('') ){
            return Swal.fire('Error', 'Formulario incorrecto por favor llene todos los campos', 'error');
        }

        if(proveedor.length < 1){
            return Swal.fire('Error', 'Selecciona al menos un proveedo.', 'error');
        }

        const result = await Swal.fire({
            title: `${id ? 'Actualizar' : 'Crear'} Producto`,
            text: `¿Está seguro de que desea ${id ? 'actualizar' : 'crear'} el producto?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Sí, ${id ? 'actualizar' : 'crear'}`,
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const resp = await startSavingProducto({ ...formProducto, id });
        if (resp) {
            if (!id) {
                setFormProducto(initialState);
            } else {
                queryClient.invalidateQueries({ queryKey: ['producto-id', id] });
            }
            queryClient.invalidateQueries({ queryKey: ['productos-list'] });
        }
    }



    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Nombre'
                        type='text'
                        placeholder='Nombre'
                        fullWidth
                        name='nombre'
                        value={ nombre }
                        onChange={ handleChangeInput }
                    />
                </Grid>

                {(unimedidaListQuery?.data?.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        select
                        label="Unidad Medida"
                        fullWidth
                        name='unidadMedida'
                        value={ unidadMedida }
                        onChange={handleChangeInput}
                    >
                        <MenuItem value="">Seleccione Medida</MenuItem>
                        {Array.isArray(unimedidaListQuery?.data) && unimedidaListQuery.data.length > 0 ? (
                            unimedidaListQuery.data.map((g) => (
                                <MenuItem key={g.id} value={g.id}>
                                    {g.nombre}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>No hay medidas disponibles</MenuItem>
                        )}
                    </TextField>
                </Grid>
                }

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Iva'
                        type='number'
                        placeholder='Iva'
                        fullWidth
                        name='iva'
                        value={ iva }
                        onChange={ handleChangeInput }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputSeparadorDecimal required
                        label='Precio Sin Iva'
                        placeholder='Precio Sin Iva'
                        fullWidth
                        name='precioSin'
                        value={ precioSin }
                        onChange={ handleChangeInput }
                    />
                </Grid>

                {(categoriasQuery?.data?.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        select
                        label="Categoria"
                        fullWidth
                        name='categoria'
                        value={categoria}
                        onChange={handleChangeInput}
                    >
                        <MenuItem value="">Seleccione Categoria</MenuItem>
                        {Array.isArray(categoriasQuery?.data) && categoriasQuery.data.length > 0 ? (
                            categoriasQuery.data.map((g) => (
                                <MenuItem key={g.id} value={g.id}> {g.nombre} </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>No hay categorias disponibles</MenuItem>
                        )}
                    </TextField>
                </Grid>
                }

                {(proveedoresListQuery?.data?.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <AutocompleteMultiple
                        label="Selecciona Proveedor"
                        options={proveedoresListQuery?.data}
                        value={proveedor}
                        onChange={(newValues) => setFormProducto({ ...formProducto, proveedor: newValues })}
                    />
                </Grid>
                }

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label="Detalles"
                        placeholder='Detalles del Producto'
                        multiline
                        fullWidth
                        name="detalles"
                        value={ detalles }
                        onChange={ handleChangeInput }
                    />
                </Grid>

            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        {`${id ? 'Actualizar' : 'Crear'} Producto`}
                    </Button>
                </Grid>
            </Grid>
        </form>
 
    )
}
